import {NgModule} from '@angular/core';
import {ProgressBarModule} from 'angular-progress-bar'
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {routing} from '../app.routes';
import {BzTabModule} from '../shared/components/tab/tab.module';
import {SharedModule} from '../shared/shared.module';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {HttpClient, HttpClientModule} from '@angular/common/http';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {UserJobsListComponent} from './user-Jobs/user-jobs-list/user-jobs-list.component';
import {UserJobsDescriptionComponent} from './user-Jobs/user-jobs-description/user-jobs-description.component';
import {UserJobsService} from './user-Jobs/user-jobs.service';
import {UserJobsComponent} from './user-Jobs/user-jobs.component';
import {AlertsComponent} from './alerts/alerts.component';
import {WaitsComponent} from './waits/waits.component';
import {JobsService} from './jobs/jobs.service';
import {UserJobsWrapperComponent} from './user-Jobs/user-jobs-wrapper/user-jobs-wrapper.component';
import {UserJobsListFilter} from './user-Jobs/user-jobs-list/user-jobs-list.filter';
import {ResultErrorsComponent} from './jobs/result-errors/result-errors.component';
import {JobsFilterComponent} from './jobs/jobs-filter/jobs-filter.component';
import {JobSettingsComponent} from './jobs/job-settings/job-settings.component';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import {JobsTableComponent} from './jobs/jobs-table/jobs-table.component';
import {JobSchedulesComponent} from './jobs/job-schedules/job-schedules.component';
import {PortalModule} from '@angular/cdk/portal';
import {JobsDetailComponent} from './jobs/jobs-detail/jobs-detail.component';
import {JobExecutionComponent} from './jobs/job-execution/job-execution.component';
import {JobsStepsComponent} from './jobs/jobs-steps/jobs-steps.component';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './i18n/', '.json');
}


@NgModule({
  imports: [
    BsDatepickerModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    HttpClientModule,
    ProgressBarModule,
    routing,
    CommonModule,
    FormsModule,
    BzTabModule,
    SharedModule,
    PortalModule
  ],
  declarations: [
    UserJobsComponent,
    UserJobsWrapperComponent,
    UserJobsListComponent,
    UserJobsListFilter,
    UserJobsDescriptionComponent,
    JobSettingsComponent,
    AlertsComponent,
    WaitsComponent,
    ResultErrorsComponent,
    JobsFilterComponent,
    JobSchedulesComponent,
    JobsDetailComponent,
    JobsTableComponent,
    JobExecutionComponent,
    JobsStepsComponent
  ],
  exports: [
    UserJobsComponent
  ],
  providers: [
    UserJobsService,
    JobsService
  ],
})
export class SchedulerModule { }
